// was: const envBaseURL = "https://sails.securespectrum.dk/api";
const envBaseURL = "https://sails.securespectrum.dk/api";
export default envBaseURL
